export default "__VITE_ASSET__vArT1y$P__"